
































































import { Component } from 'vue-property-decorator';
import '@/assets/scss/pages/page-auth.scss';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import UserSelect from '@/components/common/selects/UserSelect.vue';
import Avatar from '@/components/common/Avatar.vue';
import { AdminApi } from '@/services/AdminApi';
import { CheckIcon, SendIcon } from 'vue-feather-icons';
import AButton from '@/components/common/AButton.vue';

@Component({
  name: 'contact-form',
  components: { AButton, Avatar, UserSelect, CheckIcon, SendIcon },
})
class ContactForm extends mixins(BaseMixin) {
  done = false;
  isLoading = false;

  text = '';

  async handleSubmit() {
    this.isLoading = true;
    try {
      await AdminApi.contactForm({
        message: this.text,
        user: this.user,
      });
      this.done = true;
    } catch (e) {
      console.log(e);
    }
    this.isLoading = false;
  }
}

export default ContactForm;
